import { createContext, useContext } from 'react';
export var ConfigContext = createContext({});
export function useConfig() {
    return useContext(ConfigContext);
}
//# sourceMappingURL=useConfig.js.map